export function setSize (inputUrl, width, height) {
  const parts = inputUrl.match(/^(https?:\/\/res\.cloudinary\.com\/.*?\/upload)(\/?.*?)(\/v\d{10,}.*?)(\..+)$/i);
  if (parts === null) {
    return inputUrl;
  }
  return `${parts[1]}/c_fill,g_auto,w_${width},h_${height}${parts[3]}${parts[4]}`;
}
